var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 48 48",
    fill: "primary",
    className: "css-zbzjbd e11k6mr30",
    style: {
      minWidth: 40,
      minHeight: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#95BF46",
    d: "M39.785 9.426a.462.462 0 0 0-.417-.388c-.174-.014-3.844-.286-3.844-.286s-2.55-2.53-2.829-2.811c-.28-.28-.827-.195-1.039-.132l-1.426.44c-.852-2.45-2.355-4.702-4.998-4.702-.073 0-.149.003-.224.007C24.256.56 23.325.128 22.521.128c-6.16 0-9.101 7.699-10.024 11.611l-4.31 1.337c-1.336.42-1.378.461-1.554 1.72-.132.953-3.627 27.982-3.627 27.982l27.235 5.103 14.757-3.192s-5.18-35.023-5.213-35.263zm-11.06-2.711-2.305.713.002-.497c0-1.523-.212-2.749-.551-3.72 1.362.17 2.27 1.72 2.853 3.504zM24.18 3.512c.379.949.625 2.311.625 4.149 0 .094 0 .18-.002.267l-4.759 1.474c.917-3.537 2.634-5.246 4.136-5.89zM22.35 1.78c.266 0 .534.09.79.267-1.973.928-4.09 3.268-4.983 7.939l-3.762 1.165c1.047-3.563 3.532-9.371 7.955-9.371z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E8E3E",
    d: "M39.368 9.038c-.174-.014-3.844-.286-3.844-.286s-2.55-2.53-2.829-2.811a.699.699 0 0 0-.393-.18l-2.06 42.12 14.756-3.192s-5.18-35.023-5.213-35.263a.462.462 0 0 0-.417-.388"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m25.232 17.192-1.82 5.413s-1.594-.851-3.548-.851c-2.865 0-3.01 1.798-3.01 2.25 0 2.473 6.444 3.42 6.444 9.21 0 4.556-2.889 7.489-6.785 7.489-4.675 0-7.066-2.91-7.066-2.91l1.252-4.135s2.458 2.11 4.531 2.11c1.355 0 1.906-1.067 1.906-1.847 0-3.225-5.286-3.368-5.286-8.667 0-4.46 3.2-8.775 9.662-8.775 2.49 0 3.72.713 3.72.713"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/Shopify.d0e1d82e6a37c167c8f09ff09a49c2d8.svg";
export { ForwardRef as ReactComponent };